// Thin, safe wrappers around Google Analytics (gtag) and Meta Pixel (fbq).
// All calls no-op gracefully if a script is blocked or not yet loaded.
const GA_ID = "G-D7LB4TGNY9";
const CONSENT_KEY = "drs_consent";

export function getConsent() {
  if (typeof window === "undefined") return null;
  try {
    return localStorage.getItem(CONSENT_KEY); // 'granted' | 'denied' | null
  } catch (e) {
    return null;
  }
}

export function grantConsent() {
  if (typeof window === "undefined") return;
  try {
    localStorage.setItem(CONSENT_KEY, "granted");
  } catch (e) { /* storage unavailable */ }
  window.__drsConsent = true;
  if (window.gtag) {
    window.gtag("consent", "update", {
      ad_storage: "granted",
      analytics_storage: "granted",
      ad_user_data: "granted",
      ad_personalization: "granted",
    });
  }
  if (window.fbq) {
    window.fbq("consent", "grant");
    window.fbq("track", "PageView");
  }
}

export function denyConsent() {
  if (typeof window === "undefined") return;
  try {
    localStorage.setItem(CONSENT_KEY, "denied");
  } catch (e) { /* storage unavailable */ }
  window.__drsConsent = false;
  if (window.gtag) {
    window.gtag("consent", "update", {
      ad_storage: "denied",
      analytics_storage: "denied",
      ad_user_data: "denied",
      ad_personalization: "denied",
    });
  }
  if (window.fbq) window.fbq("consent", "revoke");
}

export function trackPageView(path) {
  if (typeof window === "undefined") return;
  if (window.gtag) {
    window.gtag("event", "page_view", {
      page_path: path,
      page_location: window.location.href,
      page_title: document.title,
    });
    // keep config in sync for GA4 SPA sessions
    window.gtag("config", GA_ID, { page_path: path });
  }
  if (window.fbq) window.fbq("track", "PageView");
}

// A guest submitted a contact / property-management enquiry.
export function trackLead(detail = {}) {
  if (typeof window === "undefined") return;
  if (window.gtag) window.gtag("event", "generate_lead", detail);
  if (window.fbq) window.fbq("track", "Lead", detail);
}

// A guest clicked through to a property's live booking widget (booking intent).
export function trackBookingIntent(property) {
  if (typeof window === "undefined") return;
  const detail = property
    ? { content_name: property.name, content_ids: [property.slug], content_type: "product" }
    : {};
  if (window.gtag) window.gtag("event", "begin_checkout", detail);
  if (window.fbq) window.fbq("track", "InitiateCheckout", detail);
}
